<template>
  <v-layout wrap align-start>
    <v-flex>
      <v-card class="card--flex-toolbar">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Sucursal Empresa</v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-form style="width: 100%">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :value="form.descripcion"
                    :error-messages="error_input.costo_envio"
                    min="0"
                    type="text"
                    label="Nombre de la Sucursal"
                    hint="Agregue un nombre descriptivo"
                    @input="(payload) => (form.descripcion = payload)"
                    :readonly="editar_form"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-flex xs12>
                    <v-textarea
                      :value="form.direccion"
                      clearable
                      :error-messages="error_input.direccion"
                      rows="2"
                      label="Direccion"
                      @input="(payload) => (form.direccion = payload)"
                      :readonly="editar_form"
                    />
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <h6>Ubicación</h6>
                  <p
                    class="text-color-blue text-align-justify"
                    style="padding: 10px; margin: 0"
                  >
                    * Cambia la posición del marcador arrastrando el marcador.
                  </p>
                  <p style="font-size: 10px">
                    Puede crear una zona de cobertura dando click en el mapa
                    cuando el botón de dibujar zona de cobertura esté activo
                    para generar los puntos y dibujar el polígono. <br />
                    Los puntos deben ser especificados en sentido de las
                    manecillas del reloj.
                  </p>
                </v-flex>
                <v-flex xs12>
                  <GmapMap
                    :center="positionMap"
                    :zoom="zoom_map"
                    style="width: 100%; height: 500px"
                    @click="
                      !editar_form
                        ? editar_marcador
                          ? setPositionClick($event)
                          : setPosition($event)
                        : false
                    "
                  >
                    <gmap-polygon
                      :paths="form.puntos"
                      :editable="true"
                      @paths_changed="updateEdited($event)"
                    >
                    </gmap-polygon>
                    <gmap-marker
                      :position="positionMap"
                      :clickable="true"
                      :draggable="!editar_form && editar_marcador"
                      @dragend="setPositionClick"
                    />
                  </GmapMap>
                </v-flex>
                <v-flex xs12 v-if="error_input.puntos">
                  <p style="font-size: 13px; color: red">
                    Debe de especificar al menos 3 puntos dentro del mapa
                  </p>
                </v-flex>
                <v-flex xs12 sm6>
                  <template v-if="!editar_form">
                    <v-btn
                     
                      color="green darken-1"
                      dark
                      block
                      @click="editar_marcador = !editar_marcador"
                    >
                      {{
                        editar_marcador
                          ? "Editando dirección"
                          : "Editar dirección"
                      }}
                    </v-btn>
                    <v-btn
                      color="black"
                      dark
                      block
                      @click="editar_marcador = !editar_marcador"
                    >
                      {{
                        !editar_marcador
                          ? "Dibujando Zona de cobertura"
                          : "Dibujar Zona de cobertura"
                      }}
                    </v-btn></template
                  >
                  <template v-else
                    ><v-btn
                      color="blue"
                      dark
                      block
                      @click="editar_form = false"
                    >
                      Editar Datos
                    </v-btn></template
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            v-show="!editar_form"
            color="blue darken-1"
            class="white--text"
            :loading="loading"
            :disabled="loading"
            @click="sendForm"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "SucursalEmpresaPage",
  components: {},
  data: () => ({
    editar_form: false,
    editar_marcador: true,
    dialog: false,
    loading: false,
    form: {
      descripcion: "",
      contenido: "",
      nombre_zona: "",
      costo_envio: "",
      activo: true,
      puntos: [],
      direccion: "",
      latitud: 0,
      longitud: 0,
    },
    positionMap: { lat: 0, lng: 0 },
    zoom_map: 11,
    error_input: {
      nombre_zona: "",
      costo_envio: "",
      puntos: "",
    },
    markers: [
      {
        position: { lat: 0, lng: 0 },
      },
    ],
  }),
  mounted() {
    this.loadData();
    if (!this.form.id) {
      window.navigator.geolocation.getCurrentPosition(({ coords }) => {
        this.positionMap.lat = coords.latitude;
        this.positionMap.lng = coords.longitude;
        this.zoom_map = 11;
      });
    } else {
      //const first = this.form.puntos[0];
      this.positionMap.lat = this.form.latitud;
      this.positionMap.lng = this.form.longitud;
      this.zoom_map = 12;
      this.editar_form = false;
    }
  },
  methods: {
    updateEdited(mvcArray) {
      for (let i = 0; i < mvcArray.getLength(); i++) {
        const path = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          const point = mvcArray.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        this.form.puntos = path;
      }
    },
    setPosition(position) {
      this.form.puntos.push({
        lat: position.latLng.lat(),
        lng: position.latLng.lng(),
      });
    },
    setPositionClick(position) {
      //this.center = position.latLng;
      this.form.latitud = position.latLng.lat();
      this.form.longitud = position.latLng.lng();
      this.positionMap.lat = this.form.latitud;
      this.positionMap.lng = this.form.longitud;

      this.markers[0].position = Object.assign(this.markers[0].position, {
        lat: position.latLng.lat(),
        lng: position.latLng.lng(),
      });

      this.setDireccion();
    },
    setDireccion() {
      let geocoder = new window.google.maps.Geocoder();
      let latlng = { lat: this.form.latitud, lng: this.form.longitud };
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[1]) {
            this.form.direccion = results[1].formatted_address;
          } else {
            window.alert("No results found");
          }
        }
      });
    },
    loadData() {
      this.loading = true;
      axios
        .get("/api/empresa-sucursal")
        .then(({ data }) => {
          if(data){
          this.form = data;
          this.positionMap.lat = this.form.latitud;
          this.positionMap.lng = this.form.longitud;
          this.editar_form = true;
          }
         
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendForm() {
      this.loading = true;
      axios
        .post("/api/empresa-sucursal", this.form)
        .then(({ data }) => {
          this.$_showMessage("Sucursal de Empresa Actualizado Correctamente");
          this.form.contenido = data.contenido;
        })
        .catch(() => {
          this.$_showError("Sucursal de Empresa Actualizado Correctamente");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
